export async function recentView(api, mId, pCode) {
  console.log(mId, "/", pCode)
  //최근 본 상품입력
  await api("/api/proc_pdtRecentView", { param: [mId, pCode] });
}
